/**
 * Default per-user daily AI caps — must match backend AiQuotaProperties defaults
 * (override on the API via qnaread.ai.*-daily-limit).
 */
export const AI_DAILY_LIMITS = {
  free: 10,
  pro: 35,
  team: 70,
};

export function aiLimitLabel(planId) {
  const key = planId === 'team' ? 'team' : planId === 'pro' ? 'pro' : 'free';
  return `${AI_DAILY_LIMITS[key]} / day`;
}
